import { render } from "./ProcessVideo.vue?vue&type=template&id=83f1249a&scoped=true"
import script from "./ProcessVideo.vue?vue&type=script&lang=js"
export * from "./ProcessVideo.vue?vue&type=script&lang=js"

import "./ProcessVideo.vue?vue&type=style&index=0&id=83f1249a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Liam\\Documents\\werowebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f1249a"]])

export default __exports__